module.exports = {"320116001":"大厂街道","320116004":"葛塘街道","320116005":"长芦街道","320116006":"雄州街道","320116007":"龙池街道","320116008":"程桥街道","320116009":"金牛湖街道","320116010":"横梁街道","320116011":"龙袍街道","320116012":"马鞍街道","320116013":"冶山街道","320116110":"竹镇镇","320116400":"六合开发区","320116401":"新材料产业园","320116450":"化工园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320116.json
// module id = 835
// module chunks = 0